import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface ChangerRoleInput {
  idUtilisateur: string;
  role: string;
}

export class ChangerRoleUseCase implements IUseCase<ChangerRoleInput, void> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: ChangerRoleInput): Promise<void> {
    const response = await this.repository.changerRole(input.idUtilisateur, input.role);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors du changement de role');
    }
  }
}
